import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const HourlyRateForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'hourlyrate'

    // The rule fields only show when the time rule switch is on
    const timeRuleDependency = { fieldName: 'time_rule_enabled', value: true };

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        { 
            type: 'price-currency', 
            name: 'rate', 
            label: 'hourly_rate.general.rate_label', 
            placeholder: 'hourly_rate.general.rate_placeholder', 
            apiObject: 'currency',
        }, 
        { 
            type: 'text', 
            name: 'description', 
            label: 'hourly_rate.general.description_label', 
            placeholder: 'hourly_rate.general.description_placeholder', 
        }, 

        // Time rule, only shown with the tiered hourly rates feature
        {
            type: 'switch',
            name: 'time_rule_enabled',
            label: 'hourly_rate.general.time_rule_enabled_label',
            tooltipText: 'hourly_rate.general.time_rule_enabled_tooltip',
            activeFeature: 'tiered_hourly_rates',
        },
        {
            type: 'weekday-checkboxes',
            name: 'time_rule_weekdays',
            label: 'hourly_rate.general.time_rule_weekdays_label',
            defaultValue: [0, 1, 2, 3, 4],
            dependentOn: timeRuleDependency,
            activeFeature: 'tiered_hourly_rates',
        },
        {
            type: 'time',
            name: 'time_rule_start_time',
            label: 'hourly_rate.general.time_rule_start_time_label',
            group: 'field-row',
            width: '50%',
            dependentOn: timeRuleDependency,
            activeFeature: 'tiered_hourly_rates',
        },
        {
            type: 'time',
            name: 'time_rule_end_time',
            label: 'hourly_rate.general.time_rule_end_time_label',
            tooltipText: 'hourly_rate.general.time_rule_end_time_tooltip',
            group: 'field-row',
            width: '50%',
            dependentOn: timeRuleDependency,
            activeFeature: 'tiered_hourly_rates',
        },
        {
            type: 'multiselect',
            name: 'job_workflows',
            label: 'hourly_rate.general.job_workflows_label',
            apiObject: 'job_workflow',
            apiRequest: [{
                endpoint: 'get_workflow_for_feature_list/job',
                object: 'job_workflow',
                params: {},
            }],
            allowNoneOption: false,
            showSearch: false,
            disabled_selected: 'hourly_rate.general.job_workflows_placeholder',
            tooltipText: 'hourly_rate.general.job_workflows_tooltip',
            dependentOn: timeRuleDependency,
            activeFeature: 'tiered_hourly_rates',
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default HourlyRateForm;
